import { render, staticRenderFns } from "./NAPAdvisoryManagement.vue?vue&type=template&id=4893f548&scoped=true"
import script from "./NAPAdvisoryManagement.vue?vue&type=script&lang=js"
export * from "./NAPAdvisoryManagement.vue?vue&type=script&lang=js"
import style0 from "./NAPAdvisoryManagement.vue?vue&type=style&index=0&id=4893f548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4893f548",
  null
  
)

export default component.exports